function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M416.5,191.5 C416.5,226.844 387.844,255.5 352.5,255.5 L352.5,256 L80.5,256 C36.312,256 0.5,220.187 0.5,176 C0.5,137.25 28.063,104.937 64.656,97.594 C64.656,97.063 64.5,96.563 64.5,96 C64.5,42.969 107.469,0 160.5,0 C197.938,0 230,21.625 245.844,52.875 C254.219,49.937 263.094,48 272.5,48 C316.344,48 351.844,83.25 352.406,127 L352.5,127 L352.5,127.5 C387.844,127.5 416.5,156.156 416.5,191.5 Z",
  id: "Shape",
  stroke: "none",
  fill: "#FFFFFF",
  fillRule: "nonzero"
});

var SvgCloud = function SvgCloud(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "417px",
    height: "256px",
    viewBox: "0 0 417 256",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloud, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cloud.305b7b7b.svg";
export { ForwardRef as ReactComponent };